// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import "./class-component-hooks";
import Vue from 'vue'
import VueRouter from "vue-router";
import axios from "axios";
import VueAnalytics from "vue-analytics"
import store from "./store";

import ElementUI from 'element-ui';
import locale from "element-ui/lib/locale/lang/en";
import "element-ui/lib/theme-chalk/index.css";
import 'intro.js/introjs.css'

import Dropdown from 'bp-vuejs-dropdown';
import vSelect from 'vue-select'

Vue.use(ElementUI, { locale }, Dropdown);
Vue.use(VueRouter);
Vue.component('v-select', vSelect)

Vue.config.productionTip = false

import "./assets/styles/style.scss";
import "./assets/styles/responsive.scss";
import "./assets/styles/print.scss";

axios.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    if (error.response.status === 401 || error.response.status === 500) {
      const currentLocation = window.location.pathname + window.location.hash;
      window.location.replace(
        "/Auth/SSO/DOE_SSO.php?source=" + currentLocation
      );
    }
    // maybe replace this with "return {data: []}"
    return Promise.reject(error);
  }
);

const routes = [
  {
    path: '/login',
    component: () => import('./components/Login')
  },
  {
    path: '/',
    component: () => import('./components/App'),
    async beforeEnter(to, from, next) {
      const res = await store.dispatch('userInit')
      next()
    },
    children: [
      {
        name: 'home',
        path: '',
        component: () => import('./components/Layout')
      },
      {
        name: 'mosl',
        path: '/mosl',
        component: () => import('./components/MOSLView')
      },
      {
        name: 'matrix',
        path: '/matrix',
        component: () => import('./components/MatrixView')
      },
      {
        name: 'motp',
        path: '/motp',
        component: () => import('./components/MOTPView')
      },
      {
        name: 'print',
        path: '/print',
        component: () => import('./components/Print')
      },
      {
        name: '1617orrguide',
        path: '/1617orrguide',
        component: () => import('./components/1617Guide.vue')
      },
      {
        name: '1718orrguide',
        path: '/1718orrguide',
        component: () => import('./components/1718Guide.vue')
      },
      {
        name: '1718dcrguide',
        path: '/1718dcrguide',
        component: () => import('./components/1718DCRGuide.vue')
      },
      {
        name: '1718tiptoolkit',
        path: '/1718tiptoolkit',
        component: () => import('./components/1718TIPToolkit.vue')
      }
    ]
  },
  {
    path: "*",
    redirect: "/"
  }
]



const router = new VueRouter({
  mode: "hash",
  routes: routes
});

Vue.prototype.$fiscalYearDisplay = function() {
	// var today = new Date();
	// if (today.getMonth() > 8){
	// 	var year = today.getFullYear();
	// } else {
	// 	var year = today.getFullYear() - 1;
	// }
  // return (year-1) +'-'+ year;
  return '2017-2018'
}

Vue.directive('stripDate', {
  inserted(el) {
    el.innerHTML = el.innerHTML.slice(0, 10)
  }
})

const app = new Vue({
  router,
  store
}).$mount("#app");

Vue.use(VueAnalytics, {
  id: GOOGLE_ANALYTICS_ID,
  router,
  commands: {
    // admin dashboard
    viewSchoolOverview() {
      this.$ga.event("View School Overview (TPO)", "click");
    },
    // MOSL students table filters
    moslAssessmentFilter() {
      this.$ga.event("Filter By Assessment", "filter");
    },
    moslGradeSubjectFilter() {
      this.$ga.event("Filter By Grade/Subject", "filter");
    },
    moslCourseSectionFilter() {
      this.$ga.event("Filter By Course Section", "filter");
    },
    moslStudentFilter() {
      this.$ga.event("Filter By Student", "filter");
    },
    moslDetailedData() {
      this.$ga.event("Toggle Detailed Data", "click");
    },
    // advisory rating toggle (teacher and admin)
    toggleAdvisoryRating() {
      this.$ga.event("Toggle Advisory Rating", "click");
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js